"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPortfolio = void 0;
const internal_1 = require("../../internal");
/**
 * Represents the default Portfolio for an Identity
 */
class DefaultPortfolio extends internal_1.Portfolio {
    /**
     * @hidden
     */
    constructor(identifiers, context) {
        // NOTE @monitz87: this is necessary to remove `id` from the DefaultPortfolio constructor signature
        super(Object.assign(Object.assign({}, identifiers), { id: undefined }), context);
    }
    /**
     * Determine whether this Portfolio exists on chain
     */
    exists() {
        return __awaiter(this, void 0, void 0, function* () {
            return true;
        });
    }
}
exports.DefaultPortfolio = DefaultPortfolio;
//# sourceMappingURL=DefaultPortfolio.js.map